// component
import RouterView from '@/components/router-view.vue';

import RollOutProjectListCom from './batch-out-project-list/roll-out-project-list.vue';
import RollOutProjectDetailCom from './batch-out-project-detail/roll-out-project-detail.vue';
import HandleRouting from './trans-handle/transaction-handle-routing';
import UploadAnnouncementImageCom from './upload-announcement-image/upload-announcement-image.vue';
export default [
  {
    path: 'list',
    name: 'rollOutProjectList',
    component: RollOutProjectListCom,
    meta: {
      title: '转出项目',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'detail',
    name: 'rollOutProjectDetail',
    component: RollOutProjectDetailCom,
    meta: {
      title: '项目详情',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'trans',
    component: RouterView,
    redirect: '/person-center/project/roll-out-project/trans',
    meta: {
      title: '处理',
      breadCrumbShowIndexArr: [0, 2]
    },
    children: HandleRouting
  },
  {
    path: 'upload-announcement-image',
    name: 'uploadAnnouncementImage',
    component: UploadAnnouncementImageCom,
    meta: {
      title: '上传公告照片',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  }
];

